import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page

    /**************************************************************
    -> Pageload animation
    **************************************************************/
    function pageSingleRentalsLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.wrap-blog-hero .wrap-image', { opacity: 1 })
      .to('.wrap-blog-hero .blog-title', { opacity: 1 }, '>-0.15')
      .to('.wrap-blog-hero .wrap-author img', { opacity: 1, stagger: {
        each: 0.08,
        from: 'start',
        grid: 'auto',
        ease: 'linear',
      }}, '>-0.25')
      .to('.wrap-blog-hero .wrap-author .posted-author', { opacity: 1 }, '>-0.15')
      .to('.wrap-blog-hero .wrap-author .posted-date', { opacity: 1 }, '>-0.15')
    }
    pageSingleRentalsLoadAnimation()

    /**************************************************************
    -> Single Blog content anim on scroll
    **************************************************************/
    function inViewAnimSingleBlog() {
      gsap.fromTo('.wrap-blog-content' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.5,
        scrollTrigger: '.wrap-blog-content',
      })

      gsap.fromTo('.wrap-blog-content .back-to-blog' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.5,
        scrollTrigger: '.wrap-blog-content .back-to-blog',
      })
    }
    inViewAnimSingleBlog();

    /**************************************************************
    -> Single Blog related posts anim on scroll
    **************************************************************/
    function inViewAnimSingleBlogrelated() {
      gsap.fromTo('.wrap-related-articles .wrap-news-row .related-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.wrap-related-articles .wrap-news-row',
      })
    }
    inViewAnimSingleBlogrelated();

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-blog.js